import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { z } from 'zod';
export var TargetApplicationStageName = /*#__PURE__*/function (TargetApplicationStageName) {
  TargetApplicationStageName["CANCELLATION"] = "cancellation";
  return TargetApplicationStageName;
}({});
export var TargetApplicationStage = z["enum"]([TargetApplicationStageName.CANCELLATION]);
var GenericApplicationStageChangeReason = z.object({
  id: z.string(),
  label: z.string(),
  key: z.string(),
  targetApplicationStage: z.string()
});
export var ApplicationStageChangeReason = z.object({
  id: z.string(),
  label: z.string(),
  key: z.string(),
  targetApplicationStage: TargetApplicationStage
});
export var ApplicationStageChangeReasonResponse = z.array(z.union([ApplicationStageChangeReason, GenericApplicationStageChangeReason])).transform(function (data) {
  return data.filter(function (item) {
    return ApplicationStageChangeReason.safeParse(item).success;
  });
}).pipe(z.array(ApplicationStageChangeReason));